<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-account-plus</v-icon>
              <span class="headline font-weight-bold">Cadastrar Atendente</span>
            </v-card-title>
            
            <v-divider class="mb-4"></v-divider>

            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="submit"
                lazy-validation
              >
                <v-text-field
                  v-model="nome"
                  label="Nome completo"
                  outlined
                  :rules="nameRules"
                  prepend-icon="mdi-account"
                  class="mb-4"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="username"
                  label="Username"
                  outlined
                  :rules="usernameRules"
                  prepend-icon="mdi-account-circle"
                  class="mb-4"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="senha"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  label="Senha"
                  outlined
                  :rules="senhaRules"
                  prepend-icon="mdi-lock"
                  counter
                  @click:append="showPassword = !showPassword"
                  class="mb-4"
                  required
                ></v-text-field>

                <v-checkbox
                  v-model="checkbox"
                  :rules="[v => !!v || 'Você deve concordar para continuar']"
                  label="Confirmo que as informações estão corretas"
                  required
                  class="mt-0"
                ></v-checkbox>

                <v-alert
                  v-model="erroLogin"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Username já está em uso!
                </v-alert>

                <v-alert
                  v-model="sucessoLogin"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Atendente cadastrado com sucesso!
                </v-alert>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    rounded
                    depressed
                    type="submit"
                    :disabled="!valid"
                    :loading="loading"
                    class="px-6"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Cadastrar
                  </v-btn>
                  
                  <v-btn
                    to="/listaAtendentesUnidade"
                    large
                    outlined
                    rounded
                    color="grey darken-1"
                    class="ml-2"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service';

export default {
  name: 'CadastrarAtendenteUnidade',
  data() {
    return {
      showPassword: false,
      tipo: 3,
      valid: false,
      loading: false,
      erroLogin: false,
      sucessoLogin: false,
      senha: '',
      username: '',
      nome: '',
      checkbox: true,
      nameRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length >= 8) || 'Nome deve ter pelo menos 8 caracteres'
      ],
      usernameRules: [
        v => !!v || 'Username é obrigatório',
        v => (v && v.length >= 8) || 'Username deve ter pelo menos 8 caracteres',
        v => /^[a-zA-Z0-9_]+$/.test(v) || 'Username deve conter apenas letras, números e underscores'
      ],
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 6) || 'Senha deve ter pelo menos 6 caracteres'
      ]
    };
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.erroLogin = false;
      this.sucessoLogin = false;

      try {
        const response = await administradorUnidadeService.administradorUnidade.cadastrarFuncionario(
          this.user.idLocal,
          this.username,
          this.senha,
          this.tipo,
          this.nome,
          null
        );

        if (response.data === 'usernameExistente') {
          this.erroLogin = true;
          return;
        }

        if (response.data === true) {
          this.sucessoLogin = true;
          this.$refs.form.reset();
          setTimeout(() => {
            this.$router.push('/listaAtendentesUnidade');
          }, 1500);
        }
      } catch (error) {
        console.error('Erro ao cadastrar atendente:', error);
        this.erroLogin = true;
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.usuario;
    }
  },
  mounted() {
    console.log('Component mounted');
  }
};
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>